const exclude = ['_id'];
export const hasRoleTool = (roles, tools) => {
  if (!roles || !roles.length || !tools || !tools.length) return false;
  for (let i = 0; i < roles.length; i++) {
    const settings = roles[i].settings;
    if (!settings) continue;
    const keys = Object.keys(settings).filter((e) => !exclude.includes(e));
    for (let j = 0; j < keys.length; j++) {
      const list = settings[keys[j]] || [];
      if (!Array.isArray(list)) continue;
      for (let k = 0; k < list.length; k++) {
        if (tools.includes(list[k])) return true;
      }
    }
  }
  return false;
};
export const hasRoleToolList = (roles, tools = []) => {
  if (!roles || !roles.length) return [];
  return roles.filter((role) => hasRoleTool([role], tools));
};
export const checkPageAccess = (l, roles, key = 'name', roleKey = 'menu') => {
  const res = [];
  const list = [...l];
  for (let i = 0; i < roles.length; i++) {
    const menu = roles[i].settings[roleKey] || [];
    for (let j = 0; j < list.length; j++) {
      const id = (list[j].id || list[j][key] || '').toLowerCase().replace(/ /gi, '-');
      if (
        typeof list[j].available !== 'undefined'
          ? list[j].available
          : menu.indexOf(id) > -1 || (list[j].pageIds && menu.find((e) => list[j].pageIds.includes(e)))
      ) {
        res.push(list.splice(j--, 1)[0]);
      }
    }
  }
  return res.sort((a, b) => (typeof a.order !== 'undefined' ? (a.order > b.order ? 1 : -1) : a[key] > b[key] ? 1 : -1));
};
const settings = ['menu', 'general', 'admin_menu', 'supplier_menu', 'art_menu', 'promostandards_menu'];
export const checkRouteAccess = (path, roles) => {
  if (path.meta.available) return true;
  let list = path.meta.id;
  if (!list)
    list = path.matched
      .map((e) => e.meta.id)
      .filter((e) => e)
      .reduce((a, b) => [...a, ...b]);
  if (!list || !list.length) list = [path.path];
  for (let i = 0; i < roles.length; i++) {
    for (let j = 0; j < settings.length; j++) {
      const menu = roles[i].settings[settings[j]];
      for (let j = 0; j < list.length; j++) {
        const id = list[j]
          .toLowerCase()
          .split('/')
          .filter((el) => el)[0]
          .replace(/ /gi, '-');
        if (menu?.includes(id)) {
          return true;
        }
      }
    }
  }
  return false;
};
